import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BaseButton from 'components/atoms/baseButton';
import BaseSwitch from 'components/atoms/base-switch';
import ChevronBottom from 'components/atoms/icons/chevron-bottom';
import RombIcon from 'components/atoms/icons/romb.svg?react';
import TextLeftIcon from 'components/atoms/icons/text-left.svg?react';
import SlightTurnRightIcon from 'components/atoms/icons/sign-turn-slight-right.svg?react';
import ChevronTopIcon from 'components/atoms/icons/chevron-top.svg?react';
import { useSmsAutoReplySettings } from 'infrastructure/hooks/smsAutoReplySettings/use-sms-autoreply-settings';
import classNames from 'classnames';

import s from './styles.module.scss';

import type { FC } from 'react';
import type { ISmsAutoReplySettingsTypeItem } from 'infrastructure/data-sources/sms-autoreply-settings';

type Props = {
  name: string;
  conditionText?: string;
  smsText?: string;
  actionText?: string;
  setting: ISmsAutoReplySettingsTypeItem;
  available: boolean | undefined;
};

const SettingsItem: FC<Props> = (props) => {
  const { t } = useTranslation();
  const { updateSmsAutoReplySettings, loading } = useSmsAutoReplySettings();
  const {
    name,
    conditionText,
    smsText,
    actionText,
    setting,
    available = false,
  } = props;
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleCollapse = () => {
    setIsCollapsed((prev: boolean) => !prev);
  };
  const toggleSwitch = () => {
    const data = { key: setting.key, available: !available };
    updateSmsAutoReplySettings(data);
  };
  const wrapperClassNames = classNames(s.wrapper, {
    [s.collapsed]: !isCollapsed,
  });
  return (
    <div key={setting.key} className={wrapperClassNames}>
      <div className={s.header}>
        <div className={s.title}>
          <div className={s.collapse}>
            <BaseButton
              onClick={toggleCollapse}
              icon={isCollapsed ? <ChevronBottom /> : <ChevronTopIcon />}
              type="secondary"
            />
          </div>
          <p>{name}</p>
        </div>
        <div className={s.actions}>
          <BaseSwitch
            onChange={toggleSwitch}
            checked={available}
            disabled={loading}
            label={available ? t('controls.enabled') : t('controls.disabled')}
          />
        </div>
      </div>
      {!isCollapsed && (
        <>
          <div className={s.divider} />
          <div className={s.body}>
            {conditionText && (
              <div className={s.row}>
                <div className={s.label}>
                  <RombIcon width={16} height={16} />
                  {t('smsAutoReplySettings.condition')}
                </div>
                <div className={s.text}>{conditionText}</div>
              </div>
            )}
            {smsText && (
              <div className={s.row}>
                <div className={s.label}>
                  <TextLeftIcon width={16} height={16} />
                  {t('smsAutoReplySettings.smsText')}
                </div>
                <div className={s.text}>{smsText}</div>
              </div>
            )}
            {actionText && (
              <div className={s.row}>
                <div className={s.label}>
                  <SlightTurnRightIcon width={16} height={16} />
                  {t('smsAutoReplySettings.action')}
                </div>
                <div className={s.text}>{actionText}</div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default SettingsItem;
